export const config = {
  title: "E&S Pressure Washing | Callahan, FL | Professional Pressure Washing Services",
  meta: {
    description:
      "E&S Pressure Washing provides professional pressure washing and soft washing services in Callahan, Orange Park, and Jacksonville, FL. Licensed and insured with over 4 years of experience. Military and veteran-friendly. Residential and commercial services available.",
    keywords: [
      "E&S Pressure Washing",
      "Pressure Washing Callahan FL",
      "Pressure Washing Jacksonville",
      "Soft Washing Orange Park",
      "Driveway Cleaning Florida",
      "Commercial Pressure Washing",
      "Residential Pressure Washing",
      "Deck Cleaning Callahan"
    ],
    author: "E&S Pressure Washing",
    canonicalUrl: "https://www.eandspressurewashingllc.com/",
  },
  sections: {
    header: {
      businessName: "E&S Pressure Washing",
    },
    sectionB: {
      heroTitle: "Achieve Spotless Surfaces Instantly",
      heroSubtitle: "Professional Pressure Washing Services in Callahan & Jacksonville Area",
      learnAboutText: "Get a Free Quote",
      phoneNumber: "9044891745",
      phoneLabel: "(904) 489-1745",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2170875223/photo/person-in-yellow-rubber-boots-pressure-washing-a-patio-in-a-residential-outdoor-area-during.jpg?s=612x612&w=0&k=20&c=y2O3wv5-9sNyU11XLgdKmd1nJUVLB9SdaXivbfLX5JI=",
      cardData: [
        {
          title: "Licensed & Insured",
          description:
            "Fully licensed and insured professionals with over 4 years of experience.",
        },
        {
          title: "Military Friendly",
          description:
            "Proud to serve our military and veterans with special appreciation and service.",
        },
        {
          title: "Free Quotes",
          description:
            "Customer-first approach with free estimates and competitive pricing.",
        },
      ],
      description:
        "E&S Pressure Washing is your trusted pressure washing solution in Callahan, Orange Park, and the Jacksonville area. Offering residential and commercial services, we ensure every corner is spotless, leaving no detail overlooked.",
    },
    sectionC: {
      servicesTitle: "Our Pressure Washing Services",
      servicesDescription:
        "Comprehensive pressure washing and soft washing solutions for residential and commercial properties. We utilize advanced techniques to ensure thorough cleaning without damaging your surfaces. Available Monday through Saturday, 7 AM to 7 PM, with after-hours service upon request.",
      cards: [
        {
          title: "Driveway & Sidewalk Cleaning",
          description:
            "Revive your concrete surfaces with professional pressure washing. Remove oil stains, dirt, and grime to make driveways and sidewalks look brand new.",
          imageSrc: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&q=80",
          imageAlt: "Driveway pressure washing",
        },
        {
          title: "Soft Washing Services",
          description:
            "Gentle yet effective cleaning for delicate surfaces like roofs, siding, and painted areas. Safe removal of mold, mildew, and algae without damage.",
          imageSrc: "https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?w=600&q=80",
          imageAlt: "Soft washing service",
        },
        {
          title: "Commercial Pressure Washing",
          description:
            "Parking lot cleaning, dumpster area cleaning, and commercial property maintenance. Keep your business looking professional and inviting.",
          imageSrc: "https://media.istockphoto.com/id/1753310515/photo/power-washing-a-side-walk.jpg?s=612x612&w=0&k=20&c=vUwD7CjWIqWUEMJAua1_YwP8FQeNIFPQBTrwBv_K0IM=",
          imageAlt: "Commercial pressure washing",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Gutter Cleaning",
        "Patio Cleaning",
        "Deck Cleaning",
        "Fence Cleaning",
        "Parking Lot Cleaning",
        "Dumpster Area Cleaning",
      ],
    },
    sectionD: {
      aboutTitle: "About E&S Pressure Washing",
      aboutImage: {
        src: "https://media.istockphoto.com/id/471204174/photo/worker-using-a-pressure-cleaner-on-a-sidewalk.jpg?s=612x612&w=0&k=20&c=vxPmcvckeI819dgyJb0qasddUdaaZXrydxUrF_35WFg=",
        alt: "E&S Pressure Washing team",
      },
      aboutText: [
        "E&S Pressure Washing is proud to serve the Callahan, Orange Park, and Jacksonville communities with dedication and precision. With over four years of experience, we've built our reputation on quality workmanship and exceptional customer service.",
        "As a fully licensed and insured company, we take pride in our military and veteran-friendly approach. Our customer-centric philosophy means we prioritize your satisfaction above all, providing detail-oriented services that leave no spot behind.",
        "Whether it's residential driveways, commercial parking lots, or delicate soft washing projects, we adapt our methods to suit local conditions and ensure optimal results every time. Available Monday through Saturday from 7 AM to 7 PM, with after-hours service available upon request, we're here when you need us. Contact us today for a free quote and experience the E&S difference!",
      ],
    },
    sectionE: {
      profileImage: "https://lirp.cdn-website.com/9f377793/dms3rep/multi/opt/516504078_122110267994925312_7143025144663444631_n-109w.jpg",
      profileAlt: "E&S Pressure Washing Logo",
      businessName: "E&S Pressure Washing",
      contact: {
        phone: "9044891745",
        phoneLabel: "(904) 489-1745",
        email: "espressurewashing00@gmail.com",
        website: "https://www.eandspressurewashingllc.com/",
        address: "Callahan, FL",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Callahan, FL",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27852.234!2d-81.8267!3d30.5634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e5c0e7e7e7e7e7%3A0x1234567890abcdef!2sCallahan%2C%20FL!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;